import { t } from '../../common/i18n';

export const resolveAriaSummary = (addedAmount: number, totalAmount: number): string => {
  if (addedAmount) {
    const ariaSummaryPartOne =
      addedAmount === 1
        ? t.WDX0('One item is added to shopping cart')
        : t.IMA5('{} items added to shopping cart', String(addedAmount));

    const ariaSummaryPartTwo =
      totalAmount === 1
        ? t.HTQL('There is now one item in shopping cart')
        : t.UE2G('There are now {} items in shopping cart', String(totalAmount));

    return `${ariaSummaryPartOne}. ${ariaSummaryPartTwo}.`;
  }
  return '';
};

export const resolveI18nSummary = (totalAmount: number): string => {
  if (totalAmount) {
    if (totalAmount > 1) {
      return t.ZE9V('There are {} items in your cart', String(totalAmount));
    }
    return t.CYZV('There is 1 item in your cart');
  }
  return '';
};
